import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import defaultAriaProps from 'client/utils/constants/ariaPropTypes';
import Link from 'client/components/aria/Link/Link';
import styles from './SummaryItem.module.scss';

const SummaryItem = ({ title, children, showChangeOption, change, disabled = false, variant = 'default', ...props }) => {
    const intl = useIntl();
    const dataTestId = props['data-testid'];

    const renderChange = () => {
        if (!showChangeOption) {
            return null;
        }

        return (
            <div className="govuk-grid-column-one-third govuk-body govuk-!-margin-bottom-2">
                {disabled
                    ? <span className={styles.disabledLink} data-testid={dataTestId ? `${dataTestId}.change` : undefined}>
                        {intl.formatMessage({ id: 'general.change' })}
                        <span className="govuk-visually-hidden">
                            {title}
                        </span>
                    </span>
                    : <Link onClick={() => change(false)} className={styles.link} data-testid={dataTestId ? `${dataTestId}.change` : undefined}>
                        {intl.formatMessage({ id: 'general.change' })}
                        <span className="govuk-visually-hidden">
                            {title}
                        </span>
                    </Link>
                }
            </div>
        );
    };

    if (variant === 'stacked') {
        return (
            <div className="govuk-grid-row" {...props}>
                <div className={['govuk-grid-column-two-thirds govuk-body govuk-!-font-weight-bold govuk-!-margin-bottom-2', styles.summary].join(' ')}>
                    {title}
                </div>
                {renderChange()}
                <div className={['govuk-grid-column-full govuk-body govuk-!-margin-bottom-2', styles.summary, styles.stackedContent].join(' ')}>
                    {children}
                </div>
            </div>
        );
    }

    return (
        <div className="govuk-grid-row" {...props}>
            <div className={['govuk-grid-column-one-third govuk-body govuk-!-font-weight-bold govuk-!-margin-bottom-2', styles.summary].join(' ')}>
                {title}
            </div>
            <div className={['govuk-grid-column-one-third govuk-body govuk-!-margin-bottom-2', styles.summary].join(' ')}>
                {children}
            </div>
            { showChangeOption
                ? renderChange()
                : null
            }
        </div>
    );
};

SummaryItem.propTypes = {
    ...defaultAriaProps,
    title: PropTypes.any.isRequired,
    children: PropTypes.any.isRequired,
    variant: PropTypes.oneOf(['default', 'stacked'])
};

export default SummaryItem;
